import { LitElement, html, css } from "lit"
import { customElement } from "lit/decorators.js"

@customElement("close-icon")
export class CloseIcon extends LitElement {
  static override styles = css``

  override render() {
    return html`
      <svg
        width="12px"
        height="12px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>Close</title>
        <g id="Close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="close" transform="translate(0, 0.1021)" fill="#000000" fill-rule="nonzero">
            <path
              d="M0.752398486,0.000327615426 C0.447676997,0.000407642063 0.173386346,0.185108686 0.0587220133,0.467433469 C-0.0559423192,0.749758252 0.0118849522,1.07340821 0.230256049,1.28593881 L4.94270174,5.9983842 L0.230256049,10.7108297 C0.0346299462,10.8986525 -0.0441726876,11.1775583 0.0242395587,11.439983 C0.092651805,11.7024077 0.29758879,11.9073446 0.560013509,11.9757568 C0.822438228,12.044169 1.10134403,11.9653663 1.28916672,11.7697401 L6.00161211,7.05729458 L10.7140577,11.7697401 C10.9018799,11.9653685 11.1807868,12.0441728 11.4432128,11.9757609 C11.7056389,11.907349 11.9105769,11.702411 11.9789888,11.4399849 C12.0474007,11.1775588 11.9685964,10.898652 11.772968,10.7108297 L7.06052249,5.9983842 L11.772968,1.28593881 C11.9944461,1.07065294 12.0610395,0.741480633 11.9406599,0.457035041 C11.8202802,0.172589449 11.5376228,-0.00877712235 11.2288872,0.000327615426 C11.0343388,0.00612451054 10.8496893,0.0874332576 10.7140577,0.22702814 L6.00161211,4.93947383 L1.28916672,0.22702814 C1.14818126,0.0821025075 0.954587359,0.000339401564 0.752398486,0.000327615426 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </svg>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "close-icon": CloseIcon
  }
}
